import TElogo from "../../../../assets/images/dod_logo.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import deskImg from "../../../../assets/images/DodUserLoginpannel/Desk iMAGE png.png";
import { Toaster } from "../../../components/Toaster/Toster";
import { ToastContainer } from "react-toastify";
import BtnLoader from "../../../components/Loader/btnLoader";
import Swal from "sweetalert2";
import { UserNewPasswordApi } from "../../../../services/apis/AuthService";
import {
  CreatelogActivityApi,
  pass_systemIpAddress,
  systemIpAddress,
} from "../../../../services/apis/IpAddress";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from "react-device-detect";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";

const UserChangePasswordSection = (props) => {
  let errorsObj = { newPassword: "", confirmPassword: "" };
  const location = useLocation()?.state;
  const [errors, setErrors] = useState(errorsObj);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [informationIp, setInformationIp] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const deviceType = {
    type: isMobile
      ? "Mobile"
      : isTablet
      ? "Tablet"
      : isDesktop
      ? "Desktop"
      : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other",
  };
  const navigate = useNavigate();

  const validateFields = () => {
    const errorObj = { newPassword: "", confirmPassword: "" };
    let isError = false;

    if (!newPassword) {
      errorObj.newPassword = "New password is required";
      isError = true;
    } else if (newPassword.length < 8) {
      errorObj.newPassword = "Password must be at least 8 characters long";
      isError = true;
    }

    if (!confirmPassword) {
      errorObj.confirmPassword = "Confirm password is required";
      isError = true;
    } else if (newPassword !== confirmPassword) {
      errorObj.confirmPassword = "Passwords do not match";
      isError = true;
    }

    setErrors(errorObj);
    return isError;
  };

  const handleInputChange = (e, field) => {
    if (field === "newPassword") {
      setNewPassword(e.target.value);
      if (submitted && errors.newPassword) {
        setErrors((prevErrors) => ({ ...prevErrors, newPassword: "" }));
      }
    } else if (field === "confirmPassword") {
      setConfirmPassword(e.target.value);
      if (submitted && errors.confirmPassword) {
        setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: "" }));
      }
    }
  };

  // log activity-------------------------
  // const SystemIp = async () => {
  //   try {
  //     await systemIpAddress().then((response) => {
  //       passIpAddress(response?.data?.ip);
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const passIpAddress = async (ipv4) => {
  //   try {
  //     await pass_systemIpAddress(ipv4).then((response) => {
  //       setInformationIp(response?.data);
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // useEffect(() => {
  //   SystemIp();
  // }, []);

  // const loggedActivity = async () => {
  //   const data = {
  //     ipAddress: informationIp?.query,
  //     lat: informationIp?.lat,
  //     long: informationIp?.lon,
  //     logType: "changePassword",
  //     deviceType: JSON.stringify(deviceType),
  //     city: informationIp?.city,
  //     countryCode: informationIp?.countryCode,
  //     regionCode: informationIp?.region,
  //   };
  //   try {
  //     await CreatelogActivityApi(data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (validateFields()) {
      return;
    }
    setBtnLoading(true);
    const formData = {
      email: location?.email,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };
    try {
      const res = await UserNewPasswordApi(formData);
      const resData = res?.data;
      // console.log("resData",resData);
      if (resData?.success) {
        // loggedActivity();
        Swal.fire({
          icon: "success",
          title: "Password Changed Successful",
          text: res?.data?.message,
        });
        navigate("/user/login");
      } else {
        console.log("Password reset failed");
      }
    } catch (error) {
      Toaster.error(error.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-xl">
        <div className="user-login-video-section">
          {/* <video
            className="user-login-df-video"
            autoPlay
            muted
            loop
            controls={false}>
            <source src={dfVideo} type="video/mp4" />
          </video> */}
          <div className="overlay-section"></div>
        </div>

        <div className="main-content-box row">
          <div className="col-md-6 d-flex flex-column align-items-center align-items-lg-start user-login-left-section">
            <img className="user-login-logo" src={TElogo} alt="logo" />
            <img
              className="user-login-deskimg d-none d-sm-block"
              src={deskImg}
              alt="logo2"
            />
            {/* <h1 className="text-white fw-bold">Forgot password</h1>
            <p className="text-white">Enter your email address and your password will be reset and emailed to you.</p> */}
            <hr className="bottom-line" />
          </div>

          <div className="col-md-6 user-login-right-section">
            <div className="user-login-section">
              <div className="mb-3">
                <h1 className="user-login-text mb-0">Change Password</h1>
                <h4 className="user-login-join-text text-white">
                  Enter your new password and confirm it to reset.
                </h4>
              </div>
              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label className="mb-1 text-white">
                    <strong>New Password</strong>
                  </label>
                  <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control user-login-input-box"
                    value={newPassword}
                    onChange={(e) => handleInputChange(e, "newPassword")}
                    placeholder="Type Your New Password"
                  />
                    <span
                       className="user-eyeicon-div"
                       onClick={()=>setShowPassword(!showPassword)}>
                       {showPassword ? (
                         <IoMdEyeOff size={22} />
                       ) : (
                         <IoEye size={22} />
                       )}
                    </span>
                  </div>
                  {errors.newPassword && (
                    <div className="text-danger fs-12">
                      {errors.newPassword}
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="mb-1 text-white">
                    <strong>Confirm Password</strong>
                  </label>
                  <div className="position-relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control user-login-input-box"
                      value={confirmPassword}
                      onChange={(e) => handleInputChange(e, "confirmPassword")}
                      placeholder="Confirm Your New Password"
                    />
                     <span
                       className="user-eyeicon-div"
                       onClick={()=>setShowConfirmPassword(!showConfirmPassword)}>
                       {showConfirmPassword ? (
                         <IoMdEyeOff size={22} />
                       ) : (
                         <IoEye size={22} />
                       )}
                    </span>
                  </div>
                  {errors.confirmPassword && (
                    <div className="text-danger fs-12">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>

                <div className="">
                  <button
                    type="submit"
                    className="btn text-white btn-block user-login-btn">
                    {btnLoading && <BtnLoader />} Submit
                  </button>

                  <button
                    type="button"
                    className="btn text-white mt-3 px-3"
                    onClick={() => navigate("/user/login")}>
                    <FaArrowLeft /> Go back
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserChangePasswordSection;
